import React, { Component } from 'react';
import { Row, Col, Table, PanelGroup, Panel } from "react-bootstrap";

import { ConsultPreferencias, ConsultaDatAcademicos, ConsultHistorico, ConsultaUcInscritos } from "../../funciones/BecasFunction";

import BecaCarreras from "./BecaCarreras";
let datos = "";

class BecaDetalle extends Component {
    state = {
        datosPersonales: true,
        iconChevron1: "fa fa-chevron-up",
        btnDown1: false,
        datosAcademicos: false,
        iconChevron2: "fa fa-chevron-down",
        btnDown2: true,
        cortes: 0,
        p_c1: 0,
        p_c2: 0,
        p_c3: 0,
        p_c4: 0,
        p_c5: 0,
        materias: [],
        preloaderMat: {
            icono: "fa fa-spinner fa-spin",
            texto: "Cargando Materias"
        },
        historico:[],
        preloaderHist: {
            icono: "fa fa-spinner fa-spin",
            texto: "Buscando Datos Históricos"
        },
        ucInscritas: <span><i className="fa fa-spinner fa-spin"></i>Espera...</span>
    }

    componentDidMount = () => {
        datos = this.props.datos.id_est
        ConsultPreferencias ((resp) => {
            this.setState({
                cortes: resp.cortes,
                p_c1: resp.p_corte_1,
                p_c2: resp.p_corte_2,
                p_c3: resp.p_corte_3,
                p_c4: resp.p_corte_4,
                p_c5: resp.p_corte_5,
            })
        })

        ConsultaUcInscritos (this.props.datos.id_est, (resp) => {
            this.setState({
                ucInscritas:resp
            })
        })

        ConsultaDatAcademicos (this.props.datos.id_est, (resp) => {
            this.setState({
                materias:resp
            })
        })

        ConsultHistorico (this.props.datos.id_est, (resp) => {
            let pre = ""
            if (resp.length === 0) pre = {
                icono: "",
                texto: "Este estudiante no posee archivo histórico registrado"
            }
            this.setState({
                historico: resp,
                preloaderHist: pre
            })
        })
    }

    componentWillReceiveProps = (props) => {

        if (datos !== "" && props.datos.id_est !== datos) {
            datos = props.datos.id_est

            this.setState({
                datosPersonales: true,
                iconChevron1: "fa fa-chevron-up",
                btnDown1: false,
                datosAcademicos: false,
                iconChevron2: "fa fa-chevron-down",
                btnDown2: true,
                cortes: 0,
                p_c1: 0,
                p_c2: 0,
                p_c3: 0,
                p_c4: 0,
                p_c5: 0,
                materias: [],
                preloaderMat: {
                    icono: "fa fa-spinner fa-spin",
                    texto: "Cargando Materias"
                },
                historico:[],
                preloaderHist: {
                    icono: "fa fa-spinner fa-spin",
                    texto: "Buscando Datos Históricos"
                },
                hist: false,
                ucInscritas: <span><i className="fa fa-spinner fa-spin"></i>Espera...</span>
            }, () => {
                ConsultPreferencias ((resp) => {
                    this.setState({
                        cortes: resp.cortes,
                        p_c1: resp.p_corte_1,
                        p_c2: resp.p_corte_2,
                        p_c3: resp.p_corte_3,
                        p_c4: resp.p_corte_4,
                        p_c5: resp.p_corte_5,
                    })
                })
        
                ConsultaDatAcademicos (props.datos.id_est, (resp) => {
                    this.setState({
                        materias:resp
                    })
                })

                ConsultaUcInscritos (props.datos.id_est, (resp) => {
                    this.setState({
                        ucInscritas:resp
                    })
                })
        
                ConsultHistorico (props.datos.id_est, (resp) => {
                    let pre = ""
                    if (resp.length === 0) pre = {
                        icono: "",
                        texto: "Este estudiante no posee archivo histórico registrado"
                    }
                    this.setState({
                        historico: resp,
                        preloaderHist: pre
                    })
                })
            })
        }
    }

    cambiaIcon = (btn, icon, content) => {
        this.setState ({
            [btn]: !this.state[btn],
            [content]:!this.state[content],
        }, () => {
            (this.state[btn] === true) ? this.setState({[icon]: "fa fa-chevron-down"}) : this.setState({[icon]: "fa fa-chevron-up"})
        })
    }

    render() {
        let { datos } = this.props;

        let { datosPersonales, datosAcademicos, iconChevron1, iconChevron2, cortes, materias, preloaderMat,
            historico, preloaderHist, ucInscritas } = this.state;
        
        const styles = {
            padding: 5, fontSize: 12
        }

        let nombre = (n1, n2, a1, a2) => {
            let nombre2 = "";
            let apellido2 = "";
            if (n2 !== null) nombre2 = n2;
            if (a2 !== null) apellido2 = a2;
            return `${n1} ${nombre2} ${a1} ${apellido2}`;
        }

        let tlf = (tlf) => {
            let texto = "No disponible"
            if (tlf !== null) texto = tlf;
            return texto;
        }

        let datEstudiante = () => {
            return(
                <React.Fragment>
                    <div style={{color:"000"}}><strong>Nombres y Apellidos:</strong> {nombre(datos.nombre_1, datos.nombre_2, datos.apellido_1, datos.apellido_2)}</div>
                    <div style={{color:"000"}}><strong>Cédula de Identidad:</strong> {`${datos.nacionalidad} ${datos.ci}`}</div>
                    <Row>
                        <Col md={6}>
                            <div style={{color:"000"}}><strong>Teléfono de Habitación:</strong> {tlf(datos.tlf_hab)}</div>
                        </Col>
                        <Col md={6}>
                            <div style={{color:"000"}}><strong>Teléfono Móvil:</strong> {tlf(datos.tlf_cel)}</div>
                        </Col>
                        <Col md={12}>
                            <div className="text-danger"><strong>Unidades de Crédito Inscritas:</strong> {ucInscritas}</div>
                        </Col>
                    </Row>
                </React.Fragment>
            )
        }

        let porcentajeCorte = (n) => {
            let  { p_c1, p_c2, p_c3, p_c4, p_c5 } = this.state;
            switch (n) {
                case 1: return p_c1
                case 2: return p_c2
                case 3: return p_c3
                case 4: return p_c4
                case 5: return p_c5
                default : return p_c1
            }
        }

        let cortesN = () => {
            let contenido= []
            
            for (let i = 0; i < cortes; i++){
                let titulo = porcentajeCorte(i)
                contenido.push({
                    id: i,
                    titulo: titulo
                })
            }

            let porcentaje = 50;
            if (parseInt(cortes) !== 0) porcentaje =  50 / parseInt(cortes)
            return(
                contenido.map(option => (
                    <React.Fragment key={option.id}>
                        <td align="center" width={`${(porcentaje) / 2}%`} style={styles}><strong>Nota</strong></td>
                        <td align="center" width={`${(porcentaje) / 2}%`} style={styles}><strong>{option.titulo}%</strong></td>
                    </React.Fragment>
                ))
            )
        }

        let notaCorte = (data) => {
            let contenido= [];

            for (let i = 0; i < cortes; i++){
                let porcentaje = ""
                if (i === 0) porcentaje = this.state.p_c1;
                if (i === 1) porcentaje = this.state.p_c2;
                if (i === 2) porcentaje = this.state.p_c3;
                if (i === 3) porcentaje = this.state.p_c4;
                if (i === 4) porcentaje = this.state.p_c5;

                let notaP = 0;

                notaP = (data[i] * porcentaje)/100;

                contenido.push({
                    id: `corte_${i + 1}`,
                    titulo: `Corte ${i + 1}`,
                    nota: data[i],
                    porcentaje: parseFloat(notaP).toFixed(2)
                })
            }

            let width = 50;
            if (parseInt(cortes) !== 0) width =  50 / parseInt(cortes)
            return(
                contenido.map(option => (
                    <React.Fragment key={option.id}>
                        <td title="Calificación obtenida" align="center" width={`${(width) / 2}%`} style={styles}>{option.nota}</td>
                        <td title="Conversion en cuanto al porcentaje" align="center" width={`${(width) / 2}%`} style={styles}>{option.porcentaje}</td>
                    </React.Fragment>
                ))
            )
        }

        let definitiva= (data) => {
            let notaP = 0;
            for (let i = 0; i < cortes; i++){
                let porcentaje = ""
                if (i === 0) porcentaje = this.state.p_c1;
                if (i === 1) porcentaje = this.state.p_c2;
                if (i === 2) porcentaje = this.state.p_c3;
                if (i === 3) porcentaje = this.state.p_c4;
                if (i === 4) porcentaje = this.state.p_c5;

                notaP += (data[i] * porcentaje)/100;
            }

            return Math.round(notaP);
        }

        let contenidoInsc = () => {
            if (materias.length === 0) return (
                <tr>
                    <td colSpan={parseInt(cortes * 2) + 2} width="100%" align="center" style={styles}>
                        <i className={preloaderMat.icono}></i> {preloaderMat.texto}
                    </td>
                </tr>
            )

            return(
                materias.map(option => (
                    <tr key={option.id}>
                        <td style={{fontSize:10, padding: 5}}>{option.materia_name}</td>
                        {notaCorte([option.corte_1, option.corte_2, option.corte_3, option.corte_4, option.corte_5])}
                        <td title="Calificación Acumulada" style={{fontSize:12, padding: 5}} align="center"><strong>{definitiva([option.corte_1, option.corte_2, option.corte_3, option.corte_4, option.corte_5])}</strong></td>
                    </tr>
                ))
            )
        }

        let daAcademicos = () => {
            return (
                <Row>
                    <Col md={12}>
                        <div className="table-responsive">
                            <Table striped hover bordered>
                                <tbody>
                                    <tr className="custon-back-color">
                                        <td rowSpan={2} width="40%" style={styles}><strong>Materias</strong></td>
                                        <td colSpan={parseInt(cortes * 2)} width="50%" align="center" style={styles}><strong>Cortes de Nota</strong></td>
                                        <td rowSpan={2} width="10%" align="center" style={styles}><strong>Def.</strong></td>
                                    </tr>
                                    <tr style={{backgroundColor:"#adcec9", color:"#000"}}>
                                        {cortesN()}
                                    </tr>
                                    {contenidoInsc()}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>
            )
        }

        let carreras = () => {
            if (historico.length === 0) return (
                <div align="center" className="custom-color custom-mt-10"><i className={preloaderHist.icono}></i> {preloaderHist.texto}</div>
            )

            return (
                historico.map (option => (
                    <BecaCarreras key = {option.id} historico = {option} />
                ))
            )
        }

        return (
            <React.Fragment>
                <div className="custom-alert-info">Detalles de la Solicitud de Beca</div>
                <PanelGroup accordion activeKey={datosPersonales} className="custom-alert-info custom-mt-10">
                    <Panel eventKey = {true}>
                        <Panel.Heading onClick = {()=> {this.cambiaIcon( "btnDown1", "iconChevron1", "datosPersonales")}}>
                            <Panel.Title toggle className="custom-color">
                                <Row>
                                    <Col md={10} style={{fontSize: 12}}>
                                        Datos del Estudiante
                                    </Col>
                                    <Col md={2} align="right">
                                        <i className={iconChevron1}></i>
                                    </Col>
                                </Row>
                            </Panel.Title>
                        </Panel.Heading>
                        <Panel.Body collapsible style={{paddingLeft:5, paddingRight:5, paddingTop:10}}>
                            {datEstudiante()}
                        </Panel.Body>
                    </Panel>
                </PanelGroup>

                <PanelGroup accordion activeKey={datosAcademicos} className="custom-alert-info">
                    <Panel eventKey = {true}>
                        <Panel.Heading onClick = {()=> {this.cambiaIcon( "btnDown2", "iconChevron2", "datosAcademicos")}}>
                            <Panel.Title toggle className="custom-color">
                                <Row>
                                    <Col md={10} style={{fontSize: 12}}>
                                        Datos Académicos
                                    </Col>
                                    <Col md={2} align="right">
                                        <i className={iconChevron2}></i>
                                    </Col>
                                </Row>
                            </Panel.Title>
                        </Panel.Heading>
                        <Panel.Body collapsible style={{paddingLeft:5, paddingRight:5, paddingTop:10}}>
                            {daAcademicos()}
                        </Panel.Body>
                    </Panel>
                </PanelGroup>

                <div className="custom-alert-info custom-mt-10">Datos Históricos</div>
                <div className="custom-mt-10" style={{marginBottom: 20}}>
                    {carreras()}
                </div>
            </React.Fragment>
        );
    }
}
 
export default BecaDetalle;


// WEBPACK FOOTER //
// ./src/views/Bienestar/BecaDetalle.jsx